import type { FC } from "react";

interface LoaderProps {
  message?: string;
}

export const Loader: FC<LoaderProps> = ({ message }) => {
  return (
    <div
      style={{
        minHeight: "100vh",
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        textAlign: "center",
        background:
          "linear-gradient(135deg, var(--vmx-primary) 0%, var(--vmx-primary-light) 50%, #1a3a6a 100%)",
        position: "relative",
        overflow: "hidden",
        fontFamily: "var(--vmx-font)",
      }}
    >
      {/* Decorative orbs */}
      <div
        style={{
          position: "absolute",
          top: "10%",
          left: "15%",
          width: 300,
          height: 300,
          borderRadius: "50%",
          background: "rgba(0,180,216,0.06)",
          filter: "blur(40px)",
        }}
      />
      <div
        style={{
          position: "absolute",
          bottom: "15%",
          right: "10%",
          width: 400,
          height: 400,
          borderRadius: "50%",
          background: "rgba(108,99,255,0.05)",
          filter: "blur(60px)",
        }}
      />
      <div
        style={{
          position: "absolute",
          top: "50%",
          right: "30%",
          width: 200,
          height: 200,
          borderRadius: "50%",
          background: "rgba(0,180,216,0.04)",
          filter: "blur(30px)",
        }}
      />

      {/* Content */}
      <div
        style={{
          position: "relative",
          zIndex: 1,
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          gap: 32,
        }}
      >
        {/* Logo */}
        <img
          src="/favicon.svg"
          alt="SecureCycle"
          width={64}
          height={62}
          style={{ animation: "vmx-fadeIn 600ms ease" }}
        />

        {/* Animated spinner ring */}
        <div
          style={{
            width: 48,
            height: 48,
            borderRadius: "50%",
            border: "3px solid rgba(255,255,255,0.1)",
            borderTopColor: "var(--vmx-accent)",
            animation: "vmx-spin 0.8s linear infinite",
          }}
        />

        {/* Text */}
        <div style={{ display: "flex", flexDirection: "column", gap: 8 }}>
          <div
            style={{
              fontSize: "1.125rem",
              fontWeight: 600,
              color: "#fff",
              letterSpacing: "-0.2px",
            }}
          >
            {message ?? "Loading SecureCycle..."}
          </div>
          <div
            style={{
              fontSize: "0.8125rem",
              color: "rgba(255,255,255,0.45)",
              fontWeight: 400,
            }}
          >
            Preparing your secure workspace
          </div>
        </div>
      </div>
    </div>
  );
};
